import React from "react";
import { View } from "react-native";
import Skeletons from "./Skeletons";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

const LiveStremObserverChatSkeleton = () => {
  const deviceSize = useDeviceSize();
  const isXL = deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE;

  return (
    <View
      style={{
        flex: isXL ? 0.2 : undefined,
        marginRight: isXL ? 15 : 5,
        marginLeft: isXL ? 0 : 5,
        marginTop: isXL ? 12 : 0,
        marginBottom: isXL ? 12 : 20,
      }}
    >
      <Skeletons
        height={isXL ? "calc(100vh - 120px - 55px - 24px)" : "70vh"}
        width={"100%"}
        style={{
          borderRadius: 10,
        }}
      />
    </View>
  );
};

export default LiveStremObserverChatSkeleton;
